// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require_tree ./templates
//= require core_post_webpack/sitewide_business_elements/research_interest_card/research_interest_card
// MAGIC_DESPROCKET_START
require('javascripts/core_post_webpack/sitewide_business_elements/research_interest_card/templates/card_JST.wjs.js')
require('sprocket-compat?this!javascripts/core_post_webpack/sitewide_business_elements/research_interest_card/research_interest_card.coffee')
// MAGIC_DESPROCKET_END
